/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import LetterNumbersStep from "../LetterNumbersStep.vue";
import Styles from "./Styles.vue";
import Height from "./Height.vue";
import Color from "./Color.vue";
import Preview from "./Preview.vue";
import Quantity from "./Quantity.vue";
import SizeChartModal from "../common/SizeChartModal.vue";
import "./JerseyNumbers.scss";

export default function JerseyNumbers() {
  const [isSizeChartModalOpen, setIsSizeChartModalOpen] = useState(false);

  function toggleSizeChartModal() {
    setIsSizeChartModalOpen(!isSizeChartModalOpen);
  }

  return (
    <>
      <div className="jersey-numbers">
        <LetterNumbersStep
          step={1}
          label="Select Style"
          initiallyOpen={true}
          data-testid="letter-numbers-step"
        >
          <Styles data-testid="styles" />
        </LetterNumbersStep>
        <LetterNumbersStep
          step={2}
          label="Select Height"
          slots={{
            action: () => (
              <>
                <span
                  className="jersey-numbers__size-guide-link"
                  onClick={e => {
                    e.stopPropagation();
                    toggleSizeChartModal();
                  }}
                  data-testid="jersey-numbers-size-guide-link"
                >
                  Size Guide
                </span>
              </>
            )
          }}
          data-testid="letter-numbers-step-1"
        >
          <Height data-testid="height" />
        </LetterNumbersStep>
        <LetterNumbersStep step={3} label="Select Color" data-testid="letter-numbers-step-2">
          <Color data-testid="color" />
        </LetterNumbersStep>
        <LetterNumbersStep step={4} label="Preview" data-testid="letter-numbers-step-3">
          <Preview data-testid="preview" />
        </LetterNumbersStep>
        <LetterNumbersStep step={5} label="Select Quantity" data-testid="letter-numbers-step-4">
          <Quantity data-testid="quantity" />
        </LetterNumbersStep>
      </div>
      {isSizeChartModalOpen ? (
        <SizeChartModal onOnClose={toggleSizeChartModal} data-testid="size-chart-modal" />
      ) : null}
    </>
  );
}
